import {
  FETCH_PAGINATED_CAMPAIGNS,
  FETCH_ALL_CAMPAIGNS,
  FETCH_CAMPAIGN_TYPES,
  RESET_CAMPAIGNS,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_CAMPAIGNS](state, { campaigns, pagination }) {
    state.items = campaigns;
    state.pagination = pagination;
  },

  [FETCH_ALL_CAMPAIGNS](state, campaigns) {
    state.all = campaigns;
  },

  [FETCH_CAMPAIGN_TYPES](state, types) {
    state.types = types;
  },

  [RESET_CAMPAIGNS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/campaign/mutations.js